function HiringCriteria() {
  return (
    <div className="bg-gray-50 rounded-lg p-6 mb-8">
      <h2 className="text-xl font-bold text-gray-900 mb-4">What We Look For</h2>
      <p className="text-gray-600 mb-4">
        At SellAbroad we don't care how many years of experience you have, whether you are a student or have 10 years of experience. We look for very specific things when hiring:
      </p>
      <ul className="space-y-2">
        <li className="flex items-start">
          <span className="text-[#0049ac] mr-2">•</span>
          <span className="text-gray-600">Do you have the basic skills to complete the job?</span>
        </li>
        <li className="flex items-start">
          <span className="text-[#0049ac] mr-2">•</span>
          <span className="text-gray-600">Are you a fast learner?</span>
        </li>
        <li className="flex items-start">
          <span className="text-[#0049ac] mr-2">•</span>
          <span className="text-gray-600">Are you a self starter?</span>
        </li>
        <li className="flex items-start">
          <span className="text-[#0049ac] mr-2">•</span>
          <span className="text-gray-600">Will you be dedicated to your responsibilities?</span>
        </li>
        <li className="flex items-start">
          <span className="text-[#0049ac] mr-2">•</span>
          <span className="text-gray-600">Are you going to be able to become friends and work together long term?</span>
        </li>
      </ul>
    </div>
  );
}

export default HiringCriteria;